import Api from './base-api'
import Config from '../config'
import _ from 'lodash'
import Promise from 'promise'

// {path: '', urlToExtend: '', query: {}, data: ...}
window.httpGetCache = []
let httpGetCache = window.httpGetCache
let maxCacheSize = 100
let matches = [
]
let pathMatch = path => {
  for (let item of matches) {
    if (_.startsWith(path, item)) {
      return true
    }
  }
  return false
}

// postParams 为Post时的params
// 指定responseType时，直接返回response对象
// 返回的Promise对象中，包含 cancelHandler 用于取消请求
export default (path, method, data, paramsInPath, postParams, responseType, contentType) => {
  // 如果传入postParams，则表示是包含Body的请求，不处理 data
  if (!_.isArray(data) && _.isObject(data) && !postParams) {
    let validData = {}
    if (data) {
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          if (data[key] !== undefined) {
            validData[key] = data[key]
          }
        }
      }
    }
    data = validData
  }
  let cancelHandler
  let promise
  promise = new Promise((resolve, reject) => {
    method = method && method.toLowerCase() || 'get'
    let urlToExtend = ''
    if (paramsInPath) {
      _.forEach(paramsInPath, param => {
        urlToExtend += '/' + encodeURI(param)
      })
    }
    let needCache = false
    if (pathMatch(path) && method === 'get') {
      needCache = true
      // 判断缓存是否存在结果，没有再查询
      for (let item of httpGetCache) {
        if (path === item.path && urlToExtend === item.urlToExtend && _.isEqual(item.query, data)) {
          resolve(_.cloneDeep(item.data))
          return
        }
      }
    }
    let rst = Api.http(
      _.startsWith(path, 'http') ? `${path}${urlToExtend}` : Config.API_URL + `${path}${urlToExtend}`,
      method,
      data,
      postParams,
      false,
      responseType,
      contentType
    )
    rst.promise.then(rst => {
      if (needCache) {
        if (httpGetCache.length > maxCacheSize) {
          httpGetCache.pop()
        }
      }
      resolve(rst)
    }, resp => {
      reject(resp)
    })
    cancelHandler = rst.cancelHandler
    if (promise) {
      promise['cancelHandler'] = cancelHandler
    }
  })
  if (cancelHandler) {
    promise['cancelHandler'] = cancelHandler
  }
  return promise
}
